/**
 * 프로젝트 스키마(project-schema) API.
 *
 * 입력키 / 허용값 / 다국어 문자열은 각각 Manage·Form·Modal·Detail·SearchModal
 * 5종 세트를 갖고 있고 그 안에서 엔드포인트를 직접 호출한다. 여기로 모아
 * 호출부가 경로 문자열을 몰라도 되게 한다 (`ruleEngine.js` 와 같은 이유).
 *
 * 시그니처: 두 번째 인자는 **axios 요청 config 그대로**(`{params: {...}}`) 받는다.
 * 기존 호출부가 `this.$axios.get(url, {params})` 형태라 이 모양이어야 엔드포인트
 * 문자열만 걷어내는 **기계적 치환**이 되고, 마이그레이션 중 의미가 바뀌지 않는다.
 */
import createApiInstance from '@core/utils/api/custom.instance';

const api = createApiInstance();

// ── 입력키 (ProjectInputKey) ──────────────────────

export const listInputKeys = (config) => api.get('/project-schema/input-keys', config);
export const getInputKey = (inputKeyId, config) => api.get(`/project-schema/input-keys/${inputKeyId}`, config);
export const createInputKey = (body) => api.post('/project-schema/input-keys', body);
export const updateInputKey = (inputKeyId, body) => api.put(`/project-schema/input-keys/${inputKeyId}`, body);
/** 여러 입력키를 한 번에 수정 (정렬 순서 변경 등). body = {items: [...]} */
export const updateInputKeys = (body) => api.put('/project-schema/input-keys', body);
export const deleteInputKey = (inputKeyId) => api.delete(`/project-schema/input-keys/${inputKeyId}`);

// ── 허용값 (KeyAllowedValue) ──────────────────────

export const listAllowedValues = (config) => api.get('/project-schema/allowed-values', config);
/** body = {input_key_id, items: [...]} */
export const createAllowedValues = (body) => api.post('/project-schema/allowed-values', body);
/** body = {items: [{id, ...}]} */
export const updateAllowedValues = (body) => api.put('/project-schema/allowed-values', body);
export const deleteAllowedValue = (allowedValueId) => api.delete(`/project-schema/allowed-values/${allowedValueId}`);

// ── 다국어 문자열 (LocalizedString) ───────────────

export const listLocalizedStrings = (config) => api.get('/project-schema/localized-strings', config);
export const getLocalizedString = (key) => api.get(`/project-schema/localized-strings/${key}`);
export const createLocalizedString = (body) => api.post('/project-schema/localized-strings', body);
export const updateLocalizedString = (key, body) => api.put(`/project-schema/localized-strings/${key}`, body);
export const deleteLocalizedString = (key) => api.delete(`/project-schema/localized-strings/${key}`);

// ── 프로젝트 단위 조회 ────────────────────────────

/** 신청 화면이 쓰는 공개 스키마 (무인증). */
export const getProjectSchema = (projectId) => api.get(`/project-schema/projects/${projectId}/schema`);

/**
 * 이 프로젝트로 지금 신청이 가능한 상태인지 (관리자용 상세).
 *
 * 규칙셋과 입력키는 서로 다른 탭에서 따로 등록되고 순서 강제가 없어서, 규칙만
 * 만들고 입력키를 빠뜨린 프로젝트가 조용히 만들어질 수 있다. 그 경우 신청자
 * 전원이 실패하므로 관리자 화면에서 미리 보여준다.
 *
 * 응답: {required, ready, reason, missing_keys, rule_set_count,
 *        evaluable_rule_set_count, fallback_campaign_id}
 */
export const getCampaignReadiness = (projectId) =>
    api.get(`/project-schema/projects/${projectId}/campaign-readiness`);
